import { TOTAL_AREA } from 'constants/actionTypes';

const initialState = 0;

export default (state = initialState, action) => {
  switch (action.type) {
    case TOTAL_AREA:
      return Math.round(action.area);
    default:
      return state;
  }
};
